import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  title: {
    id: `intro-page.case01.title`,
  },
  accordionItem1Title: {
    id: `lms.case02.accordion.item1.title`,
  },
  accordionItem1Description: {
    id: `lms.case02.accordion.item1.description`,
  },
  accordionItem2Title: {
    id: `lms.case02.accordion.item2.title`,
  },
  interviews1Title: {
    id: `lms.case02.interviews1.title`,
  },
  interviews1Description: {
    id: `lms.case02.interviews1.description`,
  },
});
